import { Select } from '@hqo/react-components-library/dist/select';
import styled from 'styled-components';

export const StyledSelect = styled(Select)`
  margin-bottom: 32px;
`;
